import React from 'react'
import { Tab } from 'semantic-ui-react'
import BPAdd from './BPAdd';
import BPSTS from './BPSTS';
import BPTrash from './BPTrash';
import BPNonSTS from './BPNonSTS';
// import RegisterBP from './RegisterBP';

const panes = [
   { 
      menuItem: 'BP Belum STS', 
      render: () => <Tab.Pane attached={false}><BPNonSTS /></Tab.Pane> 
   },
   { 
      menuItem: 'BP Telah STS', 
      render: () => <Tab.Pane attached={false}><BPSTS /></Tab.Pane> 
   },
   { 
      menuItem: 'BP Terhapus', 
      render: () => <Tab.Pane attached={false}><BPTrash /></Tab.Pane> 
   },
   { 
      menuItem: 'Buat BP Baru', 
      render: () => <Tab.Pane attached={false}><BPAdd /></Tab.Pane> 
   },
   // { 
   //    menuItem: 'Register BP', 
   //    render: () => <Tab.Pane attached={false}><RegisterBP /></Tab.Pane> 
   // },
   
]

const BPIndex = () => (
  <Tab menu={{ pointing: true }} panes={panes} />
)

export default BPIndex;


// WEBPACK FOOTER //
// ./src/components/Content/views/opd/_bp/BPIndex.js